import React from "react";

export function Box({ as = "div", children = undefined, className = undefined, style = undefined, onClick = undefined }) {
  const Component = as;
  return (
    <Component style={style} onClick={onClick} className={className}>
      {children}
    </Component>
  );
}
